import { render, staticRenderFns } from "./processSetting.vue?vue&type=template&id=75a9d363&scoped=true"
import script from "./processSetting.vue?vue&type=script&lang=js"
export * from "./processSetting.vue?vue&type=script&lang=js"
import style0 from "./processSetting.vue?vue&type=style&index=0&id=75a9d363&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9d363",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75a9d363')) {
      api.createRecord('75a9d363', component.options)
    } else {
      api.reload('75a9d363', component.options)
    }
    module.hot.accept("./processSetting.vue?vue&type=template&id=75a9d363&scoped=true", function () {
      api.rerender('75a9d363', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/develop/processSetting.vue"
export default component.exports